/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CentreSpendAttributionData } from './CentreSpendAttributionData';
import {
    CentreSpendAttributionDataFromJSON,
    CentreSpendAttributionDataFromJSONTyped,
    CentreSpendAttributionDataToJSON,
    CentreSpendAttributionDataToJSONTyped,
} from './CentreSpendAttributionData';
import type { PartialProfitabilityData } from './PartialProfitabilityData';
import {
    PartialProfitabilityDataFromJSON,
    PartialProfitabilityDataFromJSONTyped,
    PartialProfitabilityDataToJSON,
    PartialProfitabilityDataToJSONTyped,
} from './PartialProfitabilityData';
import type { ShopPerformanceDimensionRow } from './ShopPerformanceDimensionRow';
import {
    ShopPerformanceDimensionRowFromJSON,
    ShopPerformanceDimensionRowFromJSONTyped,
    ShopPerformanceDimensionRowToJSON,
    ShopPerformanceDimensionRowToJSONTyped,
} from './ShopPerformanceDimensionRow';
import type { MediaSourceQuality } from './MediaSourceQuality';
import {
    MediaSourceQualityFromJSON,
    MediaSourceQualityFromJSONTyped,
    MediaSourceQualityToJSON,
    MediaSourceQualityToJSONTyped,
} from './MediaSourceQuality';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';

/**
 * 
 * @export
 * @interface ShopPerformanceDimensionData
 */
export interface ShopPerformanceDimensionData {
    /**
     * 
     * @type {string}
     * @memberof ShopPerformanceDimensionData
     */
    dimension?: string;
    /**
     * 
     * @type {Array<ShopPerformanceDimensionRow>}
     * @memberof ShopPerformanceDimensionData
     */
    rows?: Array<ShopPerformanceDimensionRow>;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof ShopPerformanceDimensionData
     */
    snapshot?: PrecalculationSnapshotReadMetadata | null;
    /**
     * 
     * @type {CentreSpendAttributionData}
     * @memberof ShopPerformanceDimensionData
     */
    centreSpendAttribution?: CentreSpendAttributionData | null;
    /**
     * 
     * @type {PartialProfitabilityData}
     * @memberof ShopPerformanceDimensionData
     */
    partialProfitability?: PartialProfitabilityData | null;
    /**
     * 
     * @type {MediaSourceQuality}
     * @memberof ShopPerformanceDimensionData
     */
    mediaSourceQuality?: MediaSourceQuality;
    /**
     * 
     * @type {ShopPerformanceDimensionDataFinanceScopeEnum}
     * @memberof ShopPerformanceDimensionData
     */
    financeScope?: ShopPerformanceDimensionDataFinanceScopeEnum;
}


/**
 * @export
 */
export const ShopPerformanceDimensionDataFinanceScopeEnum = {
    CanonicalSelected: 'canonical_selected'
} as const;
export type ShopPerformanceDimensionDataFinanceScopeEnum = typeof ShopPerformanceDimensionDataFinanceScopeEnum[keyof typeof ShopPerformanceDimensionDataFinanceScopeEnum];


/**
 * Check if a given object implements the ShopPerformanceDimensionData interface.
 */
export function instanceOfShopPerformanceDimensionData(value: object): value is ShopPerformanceDimensionData {
    return true;
}

export function ShopPerformanceDimensionDataFromJSON(json: any): ShopPerformanceDimensionData {
    return ShopPerformanceDimensionDataFromJSONTyped(json, false);
}

export function ShopPerformanceDimensionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShopPerformanceDimensionData {
    if (json == null) {
        return json;
    }
    return {
        
        'dimension': json['dimension'] == null ? undefined : json['dimension'],
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(ShopPerformanceDimensionRowFromJSON)),
        'snapshot': json['snapshot'] === undefined ? undefined : json['snapshot'] === null ? null : PrecalculationSnapshotReadMetadataFromJSON(json['snapshot']),
        'centreSpendAttribution': json['centreSpendAttribution'] === undefined ? undefined : json['centreSpendAttribution'] === null ? null : CentreSpendAttributionDataFromJSON(json['centreSpendAttribution']),
        'partialProfitability': json['partialProfitability'] === undefined ? undefined : json['partialProfitability'] === null ? null : PartialProfitabilityDataFromJSON(json['partialProfitability']),
        'mediaSourceQuality': json['mediaSourceQuality'] == null ? undefined : MediaSourceQualityFromJSON(json['mediaSourceQuality']),
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
    };
}

export function ShopPerformanceDimensionDataToJSON(json: any): ShopPerformanceDimensionData {
    return ShopPerformanceDimensionDataToJSONTyped(json, false);
}

export function ShopPerformanceDimensionDataToJSONTyped(value?: ShopPerformanceDimensionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dimension': value['dimension'],
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(ShopPerformanceDimensionRowToJSON)),
        'snapshot': PrecalculationSnapshotReadMetadataToJSON(value['snapshot']),
        'centreSpendAttribution': CentreSpendAttributionDataToJSON(value['centreSpendAttribution']),
        'partialProfitability': PartialProfitabilityDataToJSON(value['partialProfitability']),
        'mediaSourceQuality': MediaSourceQualityToJSON(value['mediaSourceQuality']),
        'financeScope': value['financeScope'],
    };
}

